import { useEffect, useRef, useState } from "react";

import { withRouter } from "react-router-dom";

import placeholderImage from "../../../../assets/images/placeholder.jpg";
import { config } from "../../../../config/index";
import { GET, newFetch } from "../../../../helpers/fetch";

import BellIcon from "../../../../assets/icons/bell.png";

const { SERVER_URL } = config;

const HomeNavbar = ({ sidebarToggler, history }) => {
  const user = JSON.parse(localStorage.getItem("user"));
  const [associate, setAssociate] = useState(null);
  const componentMounted = useRef(true);

  useEffect(() => {
    const fetchUser = async () => {
      let api_path = "/associate/aboutme";
      let response = await newFetch(GET, api_path);

      response.success &&
        componentMounted.current &&
        setAssociate(response.data);
    };
    if (user) {
      fetchUser();
    }
    return () => {
      // This code runs when component is unmounted
      componentMounted.current = false; // set it to false when we leave the page
    };
  }, []);

  return (
    <nav className="navbar bg-white align-center shadow-sm d-flex justify-content-between">
      <i
        className="fas fa-bars"
        onClick={sidebarToggler}
        style={{ color: "#aaa" }}
      />

      <span className="navbar-text d-flex align-center">
        <div onClick={() => history.push("/notifications")} className="pr-3">
          <img
            src={BellIcon}
            alt=""
            style={{ height: "25px", width: "25px" }}
          />
        </div>

        <div onClick={() => history.push("/setting")}>
          <img
            src={
              associate && associate.image
                ? `${SERVER_URL}/${associate.image}`
                : placeholderImage
            }
            alt="default"
            className="rounded-circle border"
            style={{ height: "30px", width: "30px" }}
            onError={(e) => {
              e.target.onerror = null; // Prevent infinite loop
              e.target.src = placeholderImage;
            }}
          />
        </div>
      </span>
    </nav>
  );
};

export default withRouter(HomeNavbar);
